module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-schedule"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Events & Schedule"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('schedule', 'schedule-sub-section')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": require("../assets/ic_schedule.svg"),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Schedule\n            ")])])]), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.title_slug,
      staticClass: "column is-narrow subnav-item"
    }, [_c('a', {
      attrs: {
        "href": _vm.$route.name + '?anchor=' + item.title_slug
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onScrollTo('schedule', item.title_slug)
        }
      }
    }, [(item.icon === 'strawberry') ? _c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": require("../assets/ic_strawberry.svg"),
        "width": "80"
      }
    }) : (item.icon === 'king') ? _c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": require("../assets/ic_kingofwing.svg"),
        "width": "80"
      }
    }) : (item.icon === 'people') ? _c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": require("../assets/ic_peopleschoice.svg"),
        "width": "80"
      }
    }) : _c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": require("../assets/ic_info.svg"),
        "width": "80"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
      staticClass: "text"
    }, [_vm._v("\n              " + _vm._s(item.title_short) + "\n            ")])])])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('schedule-sub-section', {
    attrs: {
      "id": "schedule-sub-section",
      "date": "2017-5-12",
      "title": "Friday, May 12th Schedule"
    }
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('event-sub-section', {
      key: item.id,
      attrs: {
        "id": item.title_slug,
        "slug": item.title_slug,
        "title": item.title,
        "item": item
      }
    })
  })], 2), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-025c066a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Schedule.vue
// module id = 898
// module chunks = 1